import { render, staticRenderFns } from "./PurchaseReportTab.vue?vue&type=template&id=175f5def&scoped=true&"
import script from "./PurchaseReportTab.vue?vue&type=script&lang=js&"
export * from "./PurchaseReportTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175f5def",
  null
  
)

export default component.exports